import { Users, Shield, UserCog, Crown } from 'lucide-react'

export const roles = [
  {
    label: 'Member',
    value: 'member',
    icon: Users,
  },
  {
    label: 'Trainer',
    value: 'trainer',
    icon: UserCog,
  },
  {
    label: 'Admin',
    value: 'admin',
    icon: Shield,
  },
  {
    label: 'Super Admin',
    value: 'super_admin',
    icon: Crown,
  },
  {
    label: 'System',
    value: 'system',
    icon: Shield,
  },
] as const
